import React from 'react'
import _ from 'underscore'
import { RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import store from '../../state/store'
import ManagerFilter from '../manager_filter'
import DateRangePicker from '../date_range_picker'

const TERMINAL_COLUMNS = ['closed', 'handed_over']

class PipelineFilters extends React.Component {
  onManagerChange = (value) => {
    store.emit('pipeline:filter:manager', value === '' ? 'all' : value)
  }

  onCoordinatorChange = (value) => {
    store.emit('pipeline:filter:coordinator', value === '' ? 'all' : value)
  }

  onRefresh = (e) => {
    e.preventDefault()
    store.emit('pipeline:index')
  }

  onRangeChange = (from, to) => {
    store.emit('pipeline:filter:terminal_range', { from, to })
  }

  render() {
    const p = this.props.pipeline
    const managers = p.manager_options || []
    const coordinators = p.coordinator_options || []
    const selected_manager = _.find(managers, (m) => `${m.id}` === `${p.manager_id}`) || null
    const selected_coordinator = _.find(coordinators, (m) => `${m.id}` === `${p.coordinator_id}`) || null
    const special_coordinator = ['any', 'none'].includes(`${p.coordinator_id}`) ? `${p.coordinator_id}` : null

    const onTerminalTab = TERMINAL_COLUMNS.includes(p.current_tab)

    return (
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        {onTerminalTab ? (
          <div className="flex items-center gap-2">
            <Label className="text-muted-foreground">Date range</Label>
            <DateRangePicker
              start_date={p.terminal_from}
              end_date={p.terminal_to}
              onChange={this.onRangeChange}
              align="left"
            />
          </div>
        ) : null}

        <div className="flex items-center gap-2">
          <Label className="text-muted-foreground">SDR</Label>
          <div className="w-56">
            <ManagerFilter
              managers={coordinators}
              selected={selected_coordinator}
              selected_special={special_coordinator}
              special_options={[
                {value: 'any', name: 'Any SDR'},
                {value: 'none', name: 'No SDR'},
              ]}
              placeholder="-"
              onChange={this.onCoordinatorChange}
            />
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Label className="text-muted-foreground">LS</Label>
          <div className="w-56">
            <ManagerFilter
              managers={managers}
              selected={selected_manager}
              placeholder="-"
              onChange={this.onManagerChange}
            />
          </div>
        </div>

        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          onClick={this.onRefresh}
          title="Refresh"
        >
          <RefreshCw className="size-4" />
        </Button>
      </div>
    )
  }
}

export default PipelineFilters
